module.exports = __webpack_public_path__ + "img/second-bg-container.0f4725db.svg";